import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';
import './../../../styles/global.scss';
import Skeleton from 'react-loading-skeleton';
import {UtilityColors} from "../constants/chart-color-constants"
import { withRouter } from 'react-router-dom';

class YearlyDonutChart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            labels: this.generateLabels(),
            datasets: this.generateConsumptionDataset(),
            options: this.generateConsumptionOptions(),
            responsive: true
        };
    }

    
    componentDidUpdate(prevProps) {
        // Check if data prop has changed
        if (this.props.data !== prevProps.data) {
            this.setState({
                labels: this.generateLabels(),
                datasets: this.generateConsumptionDataset(),
                // Consider also regenerating options if they depend on data
                // options: this.generateConsumptionOptions(),
            });
        }
    }

    generateLabels = () => {
        return Object.keys(this.props.data).map(x => x.charAt(0).toUpperCase() + x.slice(1))
    };

    generateConsumptionDataset() {
        
        var colorArray = [];

Object.keys(this.props.data).forEach(key => {
  switch (key.toLowerCase()) {
    case 'gas':
    case 'amr':
      colorArray.push(UtilityColors.gas);
      break;
    case 'electricity':
    case 'hh':
      colorArray.push(UtilityColors.electricity);
      break;
    case 'water':
    case 'nhh':
      colorArray.push(UtilityColors.water);
      break;
        default:
            break;
    // Add more cases as needed
  }
});


       

        return [
            {


                data: Object.values(this.props.data),
                backgroundColor: colorArray,
            }
        ];
    }

    generateConsumptionOptions() {
        return {
            legend: {
                position: 'bottom',
                display : this.props.size === "compress" ? false : true
              
                
            },
            title: {
                text: this.props.title || <Skeleton />,
                display: true,
                fontSize: this.props.size === "compress" ? 9 : 13
            },
            //onClick: (evt, element) => {
                onClick: this.props.onElementsClick || ((evt, element) => {
                if (element.length > 0) {
                    const clickedElementIndex = element[0]._index;
                    // Assuming the labels array matches the order of your data keys
                    const label = this.state.labels[clickedElementIndex];
                    const utility = label.toLowerCase(); // Adjust if your utility naming differs
    
                    var url = `/supplier-invoices?utility=${utility}`;

                    if(this.props.selectedRowKey && this.props.selectedRowKey !== '' && this.props.selectedRowKey !== 'undefined')
                    {

                        const queryParams = new URLSearchParams({
                            siteKey : this.props.selectedRowKey,
                            utility: utility.toLowerCase(),
                            tab : "supplier-invoices",
                            //date: moment(date).format("YYYY-MM-DD")
            
                          }).toString();
                        url = `/site?${queryParams}`;
            

                    }




                    setTimeout(() => {

                        this.props.history.push(url);
                        },10 * 60)                }
            }),
        };
    }

    render() {
        return (
            <div className={`chart chart-segment ${this.props.size}`}>

                <Doughnut
                    width={0}
                    responsive={true}
                    data={this.state || <Skeleton />}
                    onElementsClick={this.props.onElementsClick} // Pass the callback function here
                    options={this.state.options}
                />
            </div>
        )
    }
}

export default withRouter(YearlyDonutChart);
